<template>
  <div>
    <div class="container">
      <div class="row text-center text-lg-left">
        <div v-for="c in data" :key="c.id" class="col-lg-3 col-md-4 col-6">
          <div class="d-block mb-4 h-100">
            <button
              type="button"
              class="btn btn-sm btn-outline-danger"
              @click="eliminarImagen(c)"
              style="float: right; position: absolute; right: 0"
            >
              <i class="fa fa-trash"></i>
            </button>
            <img
              id="myImg"
              class="img-fluid img-thumbnail zoom"
              :src="c.imagen"
              alt=""
              @click="onclick(c)"
            />
            <div id="myModal" class="modal modal-img">
              <span @click="cerrarModalImg" class="close close-img">&times;</span>
              <img class="modal-content modal-img-content" id="img01" :src="imagen.imagen" />
              <div id="caption">{{ imagen.producto }}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 mt-2">
        <form class="row" action="">
          <input
            type="file"
            id="file"
            style="display: none"
            ref="file"
            v-on:change="handleFileUpload()"
          />
          <button
            v-if="file == ''"
            class="btn btn-primary btn-sm"
            type="button"
            @click="cambiarfoto"
          >
            <i class="os-icon os-icon-image"></i>
            <span>Agregar Imagen</span>
          </button>
          <button
            v-if="file != ''"
            class="btn btn-danger btn-sm"
            type="button"
            @click="cancelarFoto"
          >
            <i class="os-icon os-icon-close"></i>
            <span>Cancelar</span>
          </button>
          <button
            v-if="file != ''"
            class="btn btn-success btn-sm"
            type="button"
            @click="submitFile"
          >
            <i class="os-icon os-icon-image"></i>
            <span>Subir</span>
          </button>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import PaginationComponent from "@/components/utils/PaginationComponent";
import DynamicService from "@/services/commons/DynamicService";

export default {
  components: {
    PaginationComponent,
  },
  data() {
    return {
      imagen: "",
      data: [],
      file: "",
      current: {
        producto: "",
        errors: {
          producto: "",
        },
      },
    };
  },
  props: ["sku"],
  mounted() {
    let self = this;
    self.refreshData();
  },

  methods: {
    cerrarModalImg() {
      var modal = document.getElementById("myModal");
      modal.style.display = "none";
    },
    onclick(imagen) {
      var modal = document.getElementById("myModal");
      this.imagen = imagen;
      modal.style.display = "block";
    },
    cambiarfoto() {
      this.$refs.file.click();
    },
    cancelarFoto() {
      this.file = "";
    },
    handleFileUpload() {
      this.file = this.$refs.file.files[0];
    },
    submitFile() {
      let self = this;
      self.current.id = self.current.sku;
      let _params = {
        producto: self.sku,
      };
      DynamicService.saveImageWithPost(
        "cat",
        "producto-imagen",
        _params,
        this.file
      )
        .then((res) => {
          self.file = "";
          self.refreshData();
        })
        .catch((error) => {
          self.file = "";
        });
    },
    eliminarImagen(item) {
      let self = this;
      if (!confirm("¿Desea eliminar la imagen?")) {
        return;
      }

      DynamicService.delete("cat", "producto-imagen", item.id).then((res) => {
        self.refreshData();
      });
    },
    onPageChange(page) {
      this.currentPage = page;
      this.refreshData({});
    },
    filterData() {
      this.refreshData({});
    },
    clearFilterData() {
      this.refreshData({});
    },
    hide: function () {
      this.$data.destroy();
    },
    onRefreshData() {},
    refreshData(params) {
      let self = this;
      params = {
        producto: self.sku,
        quitar_paginacion: "true",
      };
      DynamicService.fetch("cat", "producto-imagen", params).then((res) => {
        self.data = res.data;
      });
    },
    rowClick(current) {
      /*let self = this;
      self.$router.push({
        name: "cat-centro-costos-editar",
        params: { id: current.id },
      });*/
    },
    showModalEdit() {},
  },
};
</script>
